import _ from "lodash";

import ability from "@/services/ability";
import { get, set } from "@/utils/vuex";
import isRouteForbidden from "@/router/helpers/isRouteForbidden";

import ItemsHome from "./items/home";
import ItemsProjectManager from "./items/project-manager";
import NOCTabs from "./items/k4noc";

function filterMobile(item) {
	const store = window.vm.$store;
	const inMobileApp = store.getters["config/inMobileApp"];
	return !item.mobileOnly || inMobileApp;
}

function checkFlag(item) {
	return !item.flag || window.vm.$ld.flags[item.flag];
}

function updateMenuItems() {
	const router = window.vm.$router;
	const store = window.vm.$store;

	const filterFn = item => {
		const { route } = router.resolve(item.route);
		return !isRouteForbidden(route) && filterMobile(item) && checkFlag(item);
	};

	// Filter tile and menu item visibility based on route authorization.
	store.commit("menu/setItems", _.filter(ItemsHome, filterFn));
	store.commit("menu/setPMItems", _.filter(ItemsProjectManager, filterFn));
	store.commit("menu/setNOCTabs", _.filter(NOCTabs, filterFn));
}

export default {
	namespaced: true,
	state: {
		items: [],
		pmItems: [],
		nocTabs: [],
	},

	getters: {
		items: get("items"),
		getTiles: (state, getters) => getters.items.filter(item => item.tile),

		pmItems: get("pmItems"),
		getPMTiles: (state, getters) => getters.pmItems.filter(item => item.tile),

		nocTabs: get("nocTabs"),
	},

	mutations: {
		setItems: set("items"),
		setPMItems: set("pmItems"),
		setNOCTabs: set("nocTabs"),
	},

	actions: {
		init() {
			// Event handler on user ability changes.
			ability.on("updated", updateMenuItems);
			window.vm.$ld.ldClient.on("ready", updateMenuItems);
			window.vm.$ld.ldClient.on("change", updateMenuItems);
		},
	},
};
